<template lang="pug">
#more
  .head_menu.i_pb_8
    ul
      li(
        v-for="(link, index) in menuJP.MenuList",
        :class="{ selected: checkSelect(link.PageJson) }",
        @click="itemClick"
      )
        router-link(
          tag="a",
          :to="{ name: 'Japanese', params: { page: link.PageJson } }"
        ) {{ link.MenuTitle }}
    .action
      .contact_us_btn
        svg-icon(iconClass="contact_us")
        a(href="#") Contact Us
      .lang_btn
        svg-icon(iconClass="switch_lang")
        span.wrapper
          a(href="/japanese") 
            span JP
          span /
          a(href="/") 
            span CH
          span /
          a(href="/english") 
            span ENG
</template>

<script>
import { getMenuJP } from "@/json/menu";

export default {
  name: "More",

  data() {
    return {
      menuJP: {},
    };
  },
  created() {
    this.getMenuJP();
  },
  methods: {
    getMenuJP() {
      getMenuJP().then((response) => {
        this.menuJP = response.data;
        this.$router.push({
          name: "Japanese",
          params: {
            page: this.menuJP.MenuList[0].PageJson,
          },
        });
      });
    },
    checkSelect(NAME) {
      if (NAME == this.$route.params.page) {
        return true;
      }
      return false;
    },
    itemClick() {
      this.$emit("menuExpand");
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/assets/style/common/more";

#more {
  transform: translateY(0px);
  margin-left: 13px;
}

.head_menu {
  background-color: $color_grey_ci;

  // padding-top: 103px;
  height: calc(100vh - 109px);

  ul {
    max-height: calc(100% - 80px);
    overflow: auto;
  }
}

a:hover,
a:active,
a:focus,
a:visited {
  color: $color_black_text;
}

ul li {
  list-style: none;
  width: 100%;
  height: auto;
  margin: 0;

  a {
    text-decoration: none;
    @include font(22px, $color_black_text, 600);
    padding-left: 10.8%;
    width: 100%;
    height: auto;
    display: block;
    padding-top: 35px;
    padding-bottom: 35px;
  }
}

li.selected {
  background-color: #CACCCF;
}

.action {
  position: absolute;
  bottom: 40px;
  right: 5.4%;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .lang_btn,
  .contact_us_btn {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;

    * {
      @include font(16px, $color_black_text, 600);
    }

    svg {
      @include square(24px);
      color: $color_black_text;
    }
  }

  .contact_us_btn {
    a {
      margin-left: 5px;
    }
  }

  .lang_btn {
    span.wrapper {
      margin-left: 5px;
    }
  }
}

@media (max-width: 767px) {
  .head_menu {
    height: calc(100vh - 89px);
  }

  ul li {
    list-style: none;
    width: 100%;
    height: auto;

    a {
      text-decoration: none;
      @include font(26px, $color_black_text, 600);
      padding-left: 6.7%;
      padding-top: 31px;
      padding-bottom: 31px;
    }
  }

  .action {
    position: absolute;
    bottom: 33px;
    right: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;

    .lang_btn,
    .contact_us_btn {
      * {
        @include font(22px, $color_black_text, 600);
      }

      svg {
        @include square(30px);
      }
    }

    .contact_us_btn {
      a {
        margin-left: 5px;
      }
    }

    .lang_btn {
      span.wrapper {
        margin-left: 5px;
      }
    }
  }
}

@media (max-width: 767px) {
  ul li {
    a {
      text-decoration: none;
      font-size: 4.5vw;
      padding-left: 6.7%;
      padding-top: 5.38vw;
      padding-bottom: 5.38vw;
    }
  }

  .action {
    bottom: 7vw;

    .lang_btn,
    .contact_us_btn {
      display: flex;
      align-items: center;
      margin-left: 20px;
      margin-right: 20px;

      * {
        font-size: 3.8vw;
      }

      svg {
        @include square(5.2vw);
      }
    }
  }
}
</style>
